export default function SearchIcon(){
    const searchModalAdd = () => {
		document.body.classList.add('open');
	};
    return(
        <a to="#" onClick={searchModalAdd} className="search_input nav-search search-trigger header-2-icon">
            <i className="fal fa-search"></i>
        </a>
    )
}